<template>
  <div>
    <div class="fixed-top">
      <LobbyNavbar />
    </div>

    <div class="PcDevice">
      <div class="outsideFrame" v-visible="show">
        <video loop="true" autoplay="autoplay" muted="true" id="myvideo">
          <source type="video/mp4" src="../../../public/LobbyVideo.mp4" />
        </video>

        <div class="AdLeft ">
          <a
            href="https://www.facebook.com/VietnamPrintPack?utm_source=VNPPP+Online+Expo&utm_medium=Banner&utm_campaign=Facebook"
            target="_blank"
          >
            <img src="../../assets/images/Lobby_Banner1.png" class="img-fluid" alt="..." />
          </a>
        </div>

        <div class="AdMiddleLeft">
          <a
            href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/16C4B82787D5A9E9CA252530DA1F3A2B"
            target="_blank"
          >
            <img src="../../assets/images/Lobby_Banner2.jpg" class="img-fluid" alt="..." @click="SaveEvent_Ad_left()" />
          </a>
        </div>

        <div class="AdMiddleRight ">
          <a
            href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/9D7DF16952682F4FC866DFA13B5BE185"
            target="_blank"
          >
            <img
              src="../../assets/images/Lobby_Banner3.png"
              class="img-fluid"
              alt="..."
              @click="SaveEvent_Ad_right()"
            />
          </a>
        </div>
        <div class="AdRight ">
          <a
            href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/53D5EBEC414FED262AC696A3C9A0C78F"
            target="_blank"
          >
            <img
              src="../../assets/images/Lobby_Banner4.jpg"
              class="img-fluid"
              alt="..."
              @click="SaveEvent_Ad_right2()"
            />
          </a>
        </div>

        <div class="ProAdRight">
          <router-link :to="`/ProductLaunch`">
            <img src="../../assets/images/MiddleSide_right.png" height="128px" alt="" @click="SaveEvent_log_right()" />
          </router-link>

          <span class="ProAdRight_dot"><i class="far fa-dot-circle"></i></span>
        </div>

        <div class="WebinarLeft">
          <router-link :to="`/Association`">
            <img src="../../assets/images/MiddleSide_Left.png" class="img-fluid" alt="" @click="SaveEvent_log_left()" />
            <span class="WebinarLeft_dot"><i class="far fa-dot-circle"></i></span>
          </router-link>
        </div>

        <div class="HelpDesk" @click="openDeskModal">
          <span class="HelpDesk_dot"><i class="far fa-dot-circle"></i></span>
        </div>

        <div class="OfficialNewsDesk" @click="openNewsModal">
          <span class="OfficialNewsDesk_dot"><i class="far fa-dot-circle"></i></span>
        </div>

        <router-link :to="`/Exhibitors/Page=${1}`">
          <div class="ExhArea">
            <span class="ExhArea_dot"><i class="far fa-dot-circle"></i></span>
          </div>
        </router-link>

        <router-link :to="`/PressReleases/Page=${1}`">
          <div class="NewsArea">
            <span class="NewsArea_dot"><i class="far fa-dot-circle"></i></span>
          </div>
        </router-link>

        <router-link :to="`/Videos/Page=${1}`">
          <div class="VideoArea">
            <span class="VideoArea_dot"><i class="far fa-dot-circle"></i></span>
          </div>
        </router-link>

        <div class="VidePlayer">
          <img src="../../assets/images/Lobby_Video.png" width="316px" height="178px" alt="" @click="saveVideoLog()" />
        </div>
      </div>
    </div>

    <div class="MbDevice">
      <!-- SHOWCASE SLIDER -->
      <section id="showcase" style="margin-top:78px">
        <img src="../../assets/images/MB_lobby.jpg" class="BannerHover img-fluid " alt="" />
      </section>

      <div class="d-flex justify-content-center align-items-center mt-3 mb-2">
        <div class="MbVidePlayer">
          <img src="../../assets/images/Mb_Lobby_Video.png" class="BannerHover img-fluid px-3" alt="" />
        </div>
      </div>

      <div class="mt-3 d-flex justify-content-center">
        <router-link :to="`/ProductLaunch`">
          <img
            src="../../assets/images/Mb_MiddleSide_right.png"
            class="img-fluid px-3"
            alt=""
            @click="SaveEvent_log_left()"
          />
        </router-link>
      </div>

      <div class="mt-3 mb-2 d-flex justify-content-center">
        <router-link :to="`/Association`">
          <img
            src="../../assets/images/Mb_MiddleSide_Left.png"
            class="img-fluid px-3"
            alt=""
            @click="SaveEvent_log_left()"
          />
        </router-link>
      </div>

      <div class="text-center mb-3">
        <a
          href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/16C4B82787D5A9E9CA252530DA1F3A2B"
          target="_blank"
        >
          <img
            src="../../assets/images/Admobile.jpg"
            width="420px"
            class="img-fluid px-3 mt-2"
            alt=""
            @click="SaveEvent_Ad_left()"
          />
        </a>

        <a
          href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/9D7DF16952682F4FC866DFA13B5BE185"
          target="_blank"
        >
          <img
            src="../../assets/images/Admobile2.jpeg"
            width="420px"
            class="img-fluid px-3 mt-3"
            alt=""
            @click="SaveEvent_Ad_right()"
          />
        </a>

        <a
          href="https://www.chanchao.com.tw/vietnamplasprintpack/onlineexpo/ExhibitorDetail/53D5EBEC414FED262AC696A3C9A0C78F"
          target="_blank"
        >
          <img
            src="../../assets/images/Admobile3.jpg"
            width="420px"
            class="img-fluid px-3 mt-3"
            alt=""
            @click="SaveEvent_Ad_right2()"
          />
        </a>

        <router-link :to="`/Exhibitors/Page=${1}`">
          <img src="../../assets/images/Mb_exhibition.jpg" class="img-fluid px-3 mt-3" alt="" />
        </router-link>
        <router-link :to="`/Videos/Page=${1}`">
          <img src="../../assets/images/Mb_video.jpg" class="img-fluid px-3 mt-3" alt="" />
        </router-link>

        <router-link :to="`/PressReleases/Page=${1}`">
          <img src="../../assets/images/Mb_pressrelease.jpg" class="img-fluid px-3 mt-3" alt="" />
        </router-link>

        <img src="../../assets/images/Mb_news.jpg" class="img-fluid px-3 mt-3" @click="openNewsModal" alt="" />
        <img src="../../assets/images/Mb_Information.jpg" class="img-fluid px-3 mt-3" @click="openDeskModal" alt="" />
      </div>
    </div>

    <div
      class="modal fade"
      id="HelpDesk"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title font-weight-bold" id="exampleModalLongTitle">
              Information
            </h2>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body my-2">
            <!-- <h4 class="font-weight-bold mb-4">Introduction</h4> -->

            <div class="row align-items-center">
              <div class="col-lg-12">
                <!-- <p class="mb-1" style="font-size:18px">BIO Asia–Taiwan Exhibition</p> -->

                <p>
                  VietnamPlas and VietnamPrintPack enjoy a 20 years’ legacy as the leading plastics, printing, and
                  packaging industry fairs in Vietnam, which gathered nearly 1000 exhibitors from 18 countries and
                  regions in their last edition. This year, in order to kick-start the post-pandemic economy and play a
                  vital role in boosting trade and innovations during the economic recovery process, VietnamPlas &
                  VietnamPrintPack Online Expo will be an effective platform for exhibitors to join the international
                  business arena and engage with prospects from Vietnam, Asia, and the world beyond geographical
                  boundaries, while prioritizing health and safety.
                </p>

                <p class="mt-2">
                  Welcome everyone for joining such an innovative and inspiring new exhibition model with us on 1-10
                  December, 2021！
                </p>
              </div>
            </div>

            <p class="mt-3 " style="font-size:20px">You can find us with the following links:</p>
            <div class="mt-1">
              Official Website:
              <div>
                <a class="text-primary" href="https://www.chanchao.com.tw/Vietnamplas/" target="_blank"
                  >https://www.chanchao.com.tw/Vietnamplas
                </a>
              </div>

              <div>
                <a class="text-primary" href="https://www.chanchao.com.tw/VietnamPrintPack/" target="_blank"
                  >https://www.chanchao.com.tw/VietnamPrintPack
                </a>
              </div>
            </div>

            <div class="mt-1">
              Facebook Fan page:

              <div>
                <a class="text-primary" href="https://www.facebook.com/vietnamplas" target="_blank"
                  >https://www.facebook.com/vietnamplas
                </a>
              </div>

              <div>
                <a class="text-primary" href="https://www.facebook.com/VietnamPrintPack" target="_blank"
                  >https://www.facebook.com/VietnamPrintPack
                </a>
              </div>
            </div>

            <hr />

            <h4 class="my-4 font-weight-bold">Contact Information</h4>
            <div class="my-3">
              <img src="../../assets/images/Informationlogo.jpg" width="160px" alt="" />
              <p class="font-weight-bold my-2">Chan Chao International Co., Ltd</p>

              <p class="mt-2">Tel: +886-2-26596000</p>
              <p>Fax: +886-2-26597000</p>
            </div>

            <div class="my-3">
              <u style="font-size:18px">Project Manager</u>
              <p>Mr. Akai Lin (ext.176)</p>

              <p>
                Email:
                <a class="text-primary" href="mailto:akai@chanchao.com.tw">
                  akai@chanchao.com.tw
                </a>
              </p>
            </div>

            <div class="my-3">
              <u style="font-size:18px">Sales Team</u>
              <p>Ms. Virginia Cheng (ext. 210)</p>
              <p>Ms. Gina Chou (ext. 200)</p>
              <p>Ms. Tracy Chang (ext. 185)</p>

              <p>
                Email:
                <a class="text-primary" href="mailto:exfdp@chanchao.com.tw">
                  exfdp@chanchao.com.tw
                </a>
              </p>
            </div>

            <div class="my-3">
              <u style="font-size:18px">Marketing</u>
              <p>Ms. Tracy Nguyen (ext. 187)</p>
              <p>
                Email:
                <a class="text-primary" href="mailto:tracy.nguyen@chanchao.com.tw">
                  tracy.nguyen@chanchao.com.tw
                </a>
              </p>
            </div>

            <div class="my-3">
              <u style="font-size:18px">Customer Service</u>

              <p>
                Email:
                <a class="text-primary" href="mailto:CustomerService@chanchao.com.tw">
                  CustomerService@chanchao.com.tw
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="OfficialNewsDesk"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg " role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title" id="exampleModalLongTitle">
              Official Press Release
            </h2>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body my-2">
            <div class="row align-items-center text-lg-left text-center mb-4" v-for="item in lastedNewList">
              <div class="col-lg-3 mb-3">
                <img
                  :src="`//www.chanchao.com.tw/exhibitionfiles/news/${item.NewsImg}`"
                  width="180px"
                  height="180px"
                  class="pointer"
                  @click.prevent="goLastedNewsDetial(item.NewsNo)"
                />
              </div>
              <div class="col-lg-9">
                <p class="h5 title_fontStyle pointer" @click.prevent="goLastedNewsDetial(item.NewsNo)">
                  {{ item.Topic }}
                </p>
                <p class="pointer" @click.prevent="goLastedNewsDetial(item.NewsNo)">
                  {{ item.Brief }}
                </p>
                <p class="pointer text-muted" @click.prevent="goLastedNewsDetial(item.NewsNo)">
                  {{ item.PostDate }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="NewsDetailDesk"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h2 class="modal-title" id="exampleModalLongTitle">
              Official Press Release
            </h2>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body my-2">
            <div class="row text-lg-left text-center">
              <div class="col-lg-4 mb-3">
                <img
                  :src="`//www.chanchao.com.tw/exhibitionfiles/news/${LastNewsInfo.NewsImg}`"
                  width="300px"
                  height="300px"
                />
              </div>
              <div class="col-lg-8">
                <h3>{{ LastNewsInfo.Topic }}</h3>

                <p>{{ LastNewsInfo.Brief }}</p>

                <p>Date: {{ LastNewsInfo.PostDate }}</p>
              </div>
            </div>

            <p>&zwnj;</p>

            <div v-html="LastNewsInfo.Intro"></div>

            <p class="mt-4" v-if="LastNewsInfo.Url">
              Related Link : <a :href="LastNewsInfo.Url" target="_blank"> {{ LastNewsInfo.Url }}</a>
            </p>

            <div class="my-4">
              <div class="btn btn-primary px-4" @click="backtoNewsList">Back</div>
            </div>

            <p>&zwnj;</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 彈跳聊天室教學  -->

    <div
      class="modal fade"
      id="AlertChatRoom"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog  modal-dialog-centered" role="document">
        <form enctype="multipart/form-data" id="form">
          <div class="modal-content">
            <div class="modal-header modal-header-popup">
              <h2 class="modal-title" style="font-style: italic;">
                <img src="../../assets/images/idea.png" width="37px" class="mb-2" alt="" />
                <span class="ml-1">
                  Exhibition Tips
                </span>
              </h2>
            </div>
            <div class="modal-body modal-body-popup my-2">
              <div style="font-size:18px">
                <p>
                  In order to strengthen the instant communications for visitors and exhibitors, the exhibition provides
                  "one-on-one" real-time<span class="text-primary"> CHAT </span>and<span class="text-primary">
                    VIDEO CALL </span
                  >.
                </p>

                <p class="mt-3">
                  For more details of online exhibition, please click the upper-right "<span class="text-primary"
                    >book</span
                  >" icon of the screen.
                </p>
              </div>
            </div>

            <div class="modal-footer modal-footer-popup">
              <button type="button" class="btn btn-primary py-2 px-5" @click.prevent="KnowTip()">
                OK
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import LobbyNavbar from '@/components/LobbyNavbar.vue'
  import $ from 'jquery'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      LobbyNavbar,
    },

    data() {
      return {
        NewsNo: '',
        lastedNewList: [],
        LastNewsInfo: {},
        show: false,
        CSRF_Token: '',
      }
    },

    methods: {
      KnowTip() {
        localStorage.setItem('vietnamplasprintpack_notify_202111', '0A5A5A7BBB26EBBC5166A2F2DE7F0CA4')
        $('#AlertChatRoom').modal('hide')
      },
      SaveEvent_log_right() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEvent2 = `${NowPageUrl}#bannerRight`
        console.log(OpenEvent2)

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEvent2,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      },

      SaveEvent_log_left() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEvent2 = `${NowPageUrl}#bannerLeft`
        console.log(OpenEvent2)

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEvent2,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      },

      SaveEvent_Ad_left() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEventContent = `${NowPageUrl}#LobbyAd_MiddleLeft`

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEventContent,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      },

      SaveEvent_Ad_right() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEventContent2 = `${NowPageUrl}#LobbyAd_MiddleRight`

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEventContent2,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      },

      SaveEvent_Ad_right2() {
        const vm = this

        let NowPageUrl = location.href
        let OpenEventContent3 = `${NowPageUrl}#LobbyAd_Right`

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenEventContent3,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      },

      openDeskModal() {
        $('#HelpDesk').modal('show')

        const vm = this

        let NowPageUrl = location.href
        let OpenDesURL = `${NowPageUrl}#information`
        console.log(OpenDesURL)

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenDesURL,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      },

      openNewsModal() {
        $('#OfficialNewsDesk').modal('show')

        const vm = this

        let NowPageUrl = location.href
        let OpenNewsURL = `${NowPageUrl}#news`

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenNewsURL,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      },

      saveVideoLog() {
        const vm = this

        let NowPageUrl = location.href
        let OpenVideoURL = `${NowPageUrl}#video`

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: OpenVideoURL,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      },

      backtoNewsList() {
        $('#NewsDetailDesk').modal('hide')
        $('#OfficialNewsDesk').modal('show')
      },

      goLastedNewsDetial(NewsNo) {
        $('#OfficialNewsDesk').modal('hide')

        const vm = this

        //取得最新消息詳細資料
        vm.$http
          .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/LatestNewsDetail/${vm.exhcode}/${NewsNo}?Lang=en`)
          .then((response) => {
            vm.LastNewsInfo = response.data
            $('#NewsDetailDesk').modal('show')
          })
      },

      updatavisible() {
        if (this.Roomvisible) {
          if (this.ShowRoom) {
            this.$bus.$emit('callClose')
          } else {
            this.$store.dispatch('ShowChatRoom', true)
          }
        } else {
          this.$store.dispatch('ShowChatRoom', true)
          this.$store.dispatch('Updatevisible', true)
        }
      },
    },

    computed: {
      ...mapGetters(['ListStatus', 'Roomvisible', 'ShowRoom', 'UnreadNum', 'exhcode']),
    },

    watch: {
      Roomvisible(v) {
        if (v && this.mobile) {
          document.getElementById('myDIV').classList.add('disable-pull')
        } else {
          document.getElementById('myDIV').classList.remove('disable-pull')
        }
      },

      UnreadNum(newValue) {
        if (this.UnreadNum !== newValue) {
          this.$store.dispatch('getUnread', newValue)
        }
      },
    },

    mounted() {
      let FirstEntry = localStorage.getItem('vietnamplasprintpack_notify_202111')
      if (FirstEntry !== '0A5A5A7BBB26EBBC5166A2F2DE7F0CA4') {
        $('#AlertChatRoom').modal('show')
      }
    },

    created() {
      $('.modal').modal('hide')
      const vm = this

      this.$store.dispatch('ShowChatRoom', false)

      this.$store.dispatch('updateList', false)
      this.$store.dispatch('Updatevisible', true)

      // $('#carousel-ad').carousel()

      $(function() {
        $('#carousel-ad').carousel({
          interval: 4000,
        })

        $('#carousel-ad1').carousel({
          interval: 4000,
        })

        $('#carousel-ad2').carousel({
          interval: 4000,
        })

        $('#carousel-ad3').carousel({
          interval: 4000,
        })
      })

      $(function() {
        $('#NewsDetailDesk').on('hide.bs.modal', function() {
          $('.modal-body').scrollTop(0)
        })
      })

      // setTimeout(function() {
      //   vm.show = true
      // }, 1000)

      //紀錄瀏覽

      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        vm.CSRF_Token = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: NowPageUrl,
          CSRF: vm.CSRF_Token,
        }
        vm.$http.post(url, info).then(function(response) {
          $('html,body').scrollLeft(246)

          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
          // 視覺調整置中

          vm.$http
            .get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/LatestNews/${vm.exhcode}?Type=Press&Lang=en`)
            .then((response) => {
              vm.lastedNewList = response.data
                .filter((item) => {
                  return item.archived == 1
                })
                .filter((item) => {
                  return item.PostDate.split('-')[0] > 2020
                })
              vm.show = true
            })
        })
      })
    },
  }
</script>

<style lang="scss" scoped>
  .outsideFrame {
    position: relative;
    width: 1920px;
    height: 850px;
  }
  #myvideo {
    width: 1920px;
    height: 850px;
    left: 0;
    top: 0;
    margin-top: 88px;
    z-index: -99;
    overflow-x: scroll;
    overflow-y: auto;
  }

  .ProAdRight {
    position: absolute;
    width: 221px;
    -webkit-box-pack: center;
    top: 413px;
    right: 499px;
    z-index: 100;
  }

  .WebinarLeft {
    position: absolute;
    width: 221px;
    -webkit-box-pack: center;
    top: 414px;
    left: 497px;
    z-index: 100;
  }

  .HelpDesk {
    position: absolute;

    -webkit-box-pack: center;

    width: 300px;
    height: 122px;
    top: 773px;
    left: 320px;
    z-index: 100;
    cursor: pointer;
  }

  .OfficialNewsDesk {
    position: absolute;
    -webkit-box-pack: center;
    width: 83px;
    height: 187px;
    top: 691px;
    right: 446px;
    z-index: 100;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: #ffffff52;
    }
  }

  .VidePlayer {
    position: absolute;
    width: 315px;
    height: 178px;
    top: 385px;
    left: 802px;
    -webkit-box-pack: center;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .MbVidePlayer {
    cursor: pointer;
  }

  .ExhArea {
    position: absolute;
    width: 227px;
    height: 122px;
    top: 585px;
    left: 846px;
    -webkit-box-pack: center;
    z-index: 100;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: #ffffff52;
    }
  }

  .VideoArea {
    position: absolute;
    width: 193px;
    height: 123px;
    -webkit-box-pack: center;
    top: 586px;
    left: 512px;
    z-index: 100;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: #ffffff52;
    }
  }

  .NewsArea {
    position: absolute;
    -webkit-box-pack: center;
    width: 193px;
    height: 122px;
    top: 586px;
    left: 1213px;
    z-index: 100;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background-color: #ffffff52;
    }
  }

  // 廣告板位

  .AdLeft {
    position: absolute;
    width: 160px;
    -webkit-box-pack: center;
    top: 101px;
    left: 334px;
    z-index: 100;
  }

  .AdRight {
    position: absolute;
    width: 160px;
    -webkit-box-pack: center;
    top: 101px;
    right: 329px;
    z-index: 100;
  }

  .AdMiddleLeft {
    position: absolute;
    width: 160px;
    -webkit-box-pack: center;
    top: 101px;
    left: 589px;
    z-index: 100;
  }

  .AdMiddleRight {
    position: absolute;
    width: 160px;
    -webkit-box-pack: center;
    top: 101px;
    right: 588px;
    z-index: 100;
  }

  .modal-body {
    height: 75vh;
    overflow-y: scroll;
  }

  .carousel-inner {
    position: relative;
    width: 100%;
    height: 250px;
    overflow: hidden;
  }

  .carousel-item {
    height: 350px;
  }

  .carousel-image-1 {
    background: url('../../assets/images/boothsonmobile.png');
    background-size: cover;
    width: 300px;
  }

  // 手機板banner

  .HomeTopicStyle {
    flex: 0 0 auto;
    position: relative;
    border-radius: 8px;
    overflow: hidden;
    margin: 24px 16px;
    background: center center / cover no-repeat #ada9ad;
  }

  // 閃耀點

  .ProAdRight_dot {
    position: absolute;
    left: 105px;
    top: -20px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }

  .WebinarLeft_dot {
    position: absolute;
    left: 105px;
    top: -20px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }

  .HelpDesk_dot {
    position: absolute;
    left: 153px;
    top: 0px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }
  .OfficialNewsDesk_dot {
    position: absolute;
    left: 36px;
    top: 167px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }
  .ExhArea_dot {
    position: absolute;
    left: 107px;
    top: 90px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }
  .NewsArea_dot {
    position: absolute;
    left: 82px;
    top: 90px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }
  .VideoArea_dot {
    position: absolute;
    left: 100px;
    top: 90px;
    animation: flicker 1s linear infinite;
    color: #ffee50;
  }

  @keyframes flicker {
    0% {
      opacity: 1;
    }

    50% {
      opacity: 0.3;
    }

    100% {
      opacity: 1.2;
    }
  }

  .far {
    font-size: 13px;
  }

  .modal-body-popup {
    height: 25vh;
    overflow-y: scroll;
  }

  .modal-footer-popup {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding: 0.45rem;
    border-top: 1px solid #cacacb;
    border-bottom-right-radius: calc(0.3rem - 1px);
    border-bottom-left-radius: calc(0.3rem - 1px);
  }

  .modal-header-popup {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 0.5rem 0.5rem;
    border-bottom: 1px solid #cacacb;
    border-top-left-radius: calc(0.3rem - 1px);
    border-top-right-radius: calc(0.3rem - 1px);
  }
</style>
